<template>
  <div class="body-wrapper px-15 pb-18">
    <p class="title text-pearl d-block">{{ label }}</p>
    <p class="data-value d-block">
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
</style>